export enum SectionHeaderVariant {
    Default = 'default',
    DailyChat = 'daily-chat',
}
